// extracted by mini-css-extract-plugin
export default {"container":"Documents_container__5V0GP","disclaimer":"Documents_disclaimer__PlRVr","card":"Documents_card__TqieV","icon":"Documents_icon__HTrFi"};